import { UserCompanyManager } from "@/services/UserCompanyManager"
import { Company } from "@/core/Types"
import * as db from "@/core/Database"
import { PromiseCache } from "@/core/PromiseCache"

/**
 * Class that manages/caches Company data for each retrieved companyId.
 *
 * expirationDelayMillis: Positive value sets an expiration delay in milliseconds
 *                        Zero or negative means values do not expire
 */
export class CompanyManager {
    private readonly cache: PromiseCache<string, Company|null>

    constructor(private userCompanyManager: UserCompanyManager,
                private expirationDelayMillis: number = 0) {
        this.cache = new PromiseCache<string, Company>(expirationDelayMillis)
    }

    async getCompany(companyId: string): Promise<Company|null> {
        const userCompany = this.userCompanyManager.state.company
        if (userCompany?.id === companyId) {
            return userCompany
        }

        return await this.cache.get(companyId, () => CompanyManager.retrieveCompany(companyId))
    }

    private static async retrieveCompany(companyId: string): Promise<Company|null> {
        const companyData = await db.getCompanyData(companyId)
        if (!companyData) {
            return null
        }

        return {
            id: companyId,
            data: companyData,
        } as Company
    }
}